export const SET_RECEIVING_ADDRESS = "SET_RECEIVING_ADDRESS";
export const GET_RECEIVING_ADDRESS = "GET_RECEIVING_ADDRESS";
export const SET_MY_RECEIVING_ADDRESS = "SET_MY_RECEIVING_ADDRESS";
